// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterSec_footerSec__tBYu5 {
    display: flex;
    gap: 50px;
    padding: 25px 320px;
}

.FooterSec_footerText__PfQmF {
    display: flex;
    align-items: center;
}
.FooterSec_footerText__PfQmF p{
    margin-top: revert;
}
.FooterSec_footerText__PfQmF img {
    width: 20px;
}

.FooterSec_FootBlockPrivacy__T3NXs > a {
    display: flex;
    padding: 0 305px;
    align-items: center;
    text-decoration: none;
    gap: 50px;
    color: #000000;
}

.FooterSec_coat__1kdMV img {
    width: 100px;
}

.FooterSec_otherPages__4KIoL {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 30px;
}

.FooterSec_otherPages__4KIoL > a {
    color: #1d70b8;
    text-decoration: none;
    padding: 5px;
}

.FooterSec_otherPages__4KIoL span{
    color: #1d70b8;
}

@media screen and (max-width: 1250px) {
    .FooterSec_footerSec__tBYu5 {
        padding: 25px 200px;
    }

    .FooterSec_FootBlockPrivacy__T3NXs > a {
        padding: 0 180px;
    }
}

@media screen and (max-width: 1024px) {
    .FooterSec_coat__1kdMV img {
        width: 60px;
    }

    .FooterSec_footerSec__tBYu5 {
        gap: 20px;
        padding: 25px 150px;
        align-items: center;
    }

    .FooterSec_FootBlockPrivacy__T3NXs > a {
        gap: 20px;
        padding: 25px 150px;
        align-items: center;
    }
}

@media screen and (max-width: 786px) {
    .FooterSec_footerSec__tBYu5 {
        padding: 25px 50px;
    }

    .FooterSec_FootBlockPrivacy__T3NXs > a {
        padding: 25px 0;
    }
}

@media screen and (max-width: 468px) {
    .FooterSec_footerSec__tBYu5 {
        padding: 25px 0 0 20px;
        font-size: 15px;
    }

    .FooterSec_footerText__PfQmF img {
        width: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/FooterSec.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,SAAS;QACT,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".footerSec {\n    display: flex;\n    gap: 50px;\n    padding: 25px 320px;\n}\n\n.footerText {\n    display: flex;\n    align-items: center;\n}\n.footerText p{\n    margin-top: revert;\n}\n.footerText img {\n    width: 20px;\n}\n\n.FootBlockPrivacy > a {\n    display: flex;\n    padding: 0 305px;\n    align-items: center;\n    text-decoration: none;\n    gap: 50px;\n    color: #000000;\n}\n\n.coat img {\n    width: 100px;\n}\n\n.otherPages {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 30px;\n}\n\n.otherPages > a {\n    color: #1d70b8;\n    text-decoration: none;\n    padding: 5px;\n}\n\n.otherPages span{\n    color: #1d70b8;\n}\n\n@media screen and (max-width: 1250px) {\n    .footerSec {\n        padding: 25px 200px;\n    }\n\n    .FootBlockPrivacy > a {\n        padding: 0 180px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .coat img {\n        width: 60px;\n    }\n\n    .footerSec {\n        gap: 20px;\n        padding: 25px 150px;\n        align-items: center;\n    }\n\n    .FootBlockPrivacy > a {\n        gap: 20px;\n        padding: 25px 150px;\n        align-items: center;\n    }\n}\n\n@media screen and (max-width: 786px) {\n    .footerSec {\n        padding: 25px 50px;\n    }\n\n    .FootBlockPrivacy > a {\n        padding: 25px 0;\n    }\n}\n\n@media screen and (max-width: 468px) {\n    .footerSec {\n        padding: 25px 0 0 20px;\n        font-size: 15px;\n    }\n\n    .footerText img {\n        width: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerSec": `FooterSec_footerSec__tBYu5`,
	"footerText": `FooterSec_footerText__PfQmF`,
	"FootBlockPrivacy": `FooterSec_FootBlockPrivacy__T3NXs`,
	"coat": `FooterSec_coat__1kdMV`,
	"otherPages": `FooterSec_otherPages__4KIoL`
};
export default ___CSS_LOADER_EXPORT___;
